import { Component, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { DataClientService } from 'src/app/services/data-client.service';
import { LoadingService } from 'src/app/services/loading.service';
import { RedirectService } from 'src/app/services/redirect.service';
import { SessionService } from 'src/app/services/session.service';
import { StepsClientTypes } from 'src/app/shared/enums';
import { UiActions } from 'src/app/store/actions';
import { OnboardingProductsStore } from 'src/app/store/store';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-client-flow',
  templateUrl: './client-flow.component.html',
  styleUrls: ['./client-flow.component.scss']
})
export class ClientFlowComponent implements OnInit {
  isMobile: any;
  constructor(
    public loadingService: LoadingService,
    private store: Store<OnboardingProductsStore.AppState>,
    private redirectService: RedirectService,
    private sessionService: SessionService,
    private dataClientService: DataClientService
  ) {
    this.isMobile = environment.isMobile;
  }

  steps$ = this.store.pipe(
    select(OnboardingProductsStore.selectors.stepsClient)
  );
  Step = StepsClientTypes;

  ngOnInit(): void {
    if (this.dataClientService.getValidationError()) {
      this.store.dispatch(UiActions.Navigate({ step: StepsClientTypes.STEP_SERVICE_ERROR }));
    } else {
      if (this.sessionService.isJointAccount === '0') {
        this.dataClientService.setIsJointAccount(false);
        this.store.dispatch(UiActions.Navigate({ step: StepsClientTypes.STEP_OFFER }));
      } else {
        this.dataClientService.setIsJointAccount(true);
        this.store.dispatch(UiActions.Navigate({ step: StepsClientTypes.STEP_PRIVATE_LANDING_JOINT }));
      }
    }
  }

  loadRetry() {
    switch (this.redirectService.getRedirect()) {
      case StepsClientTypes.STEP_OFFER: {
        this.loadingService.loading = true;
        this.store.dispatch(UiActions.Navigate({ step: StepsClientTypes.STEP_OFFER }));
        break;
      }
      default: {
        this.loadingService.loading = true;
        this.store.dispatch(UiActions.Navigate({ step: StepsClientTypes.STEP_SERVICE_ERROR }));
      }
    }
  }
}
